/**
 * Hubtype service
 */
(function () {
    'use strict';

    angular.module('itxApp.common').service('ItxHubtypeSvc', ItxHubtypeSvc);

    ItxHubtypeSvc.$inject = ['CmsConfigSvc', 'ItxTranslateSvc', 'DUTTI_CONS', '$rootScope', '$q'];

    function ItxHubtypeSvc(CmsConfigSvc, ItxTranslateSvc, DUTTI_CONS, $rootScope, $q) {
        var service = {
            initWidget: _initWidget,
            isEnabled: _isEnabled,
            getDataFromUser: _getDataFromUser,
            checkSupportedLanguages: _checkSupportedLanguages
        };

        return service;

        /**
         * Inicializa el widget en la página
         */
        function _initWidget(config) {
            // Añadimos el script a la página
            var hubtypeScript = document.createElement('script');
            hubtypeScript.src = config.url;
            
            setTimeout(() => {
                document.head.appendChild(hubtypeScript);
            }, 1000);

            // Una vez se haya cargado la libreria
            hubtypeScript.onload = function () {
                // Aádimos Hubtype en el DOM pasándole la configuración y el tipo
                var element = document.getElementById('chatbot-botonic');

                config.menu.forEach((element) => {
                    if (element.label) {
                        element.label = ItxTranslateSvc.translateCms(element.label);
                    } else {
                        element.closeLabel = ItxTranslateSvc.translateCms(element.closeLabel);
                    }
                });

                // Definimos la configuración de Hubtype
                var botConfig = {
                    appId: config.appId,
                    theme: {
                        userInput: {
                            box: {
                                placeholder: ItxTranslateSvc.translateCms(config.placeHolder)
                            }
                        },
                        header: {
                            title: ItxTranslateSvc.translateCms(config.title)
                        },
                        persistentMenu: config.menu
                    },
                    onInit: (app) => {
                        var data = _getDataFromUser();
                        app.updateUser(data);

                        // Comprobamos si el chat es de tipo Moca y además existe la función creada por el equipo de Hubtype
                        if( config.isMoca && typeof window.mochatClientOnInit == "function"){
                            window.mochatClientOnInit();
                        }

                        // Si Hubtype esta en uso, abrimos la ventana
                        if (inditex.getLocalStorage('hubtypeInUse')) {
                            window.Botonic.open();
                            $('#chatbot-botonic').show();

                            $rootScope.$broadcast('changeChatVisualizations', {
                                event: 'hideButton'
                            });
                        }
                    },
                    onOpen: (app) => {
                        app.addUserPayload('POSTBACK_GET_STARTED_BUTTON');
                        
                        // Comprobamos si el chat es de tipo Moca y además existe la función creada por el equipo de Hubtype
                        if( config.isMoca && typeof window.mochatClientOnOpen == "function"){
                            window.mochatClientOnOpen();
                        }
                    },
                    onClose: (app) => {
                        $('#chatbot-botonic').hide();

                        // Quitamos del storage el control de uso
                        inditex.removeLocalStorage('hubtypeInUse');

                        $rootScope.$broadcast('changeChatVisualizations', {
                            event: 'showButton'
                        });
                    }
                };
                if (window.Botonic) {
                    window.Botonic.render(element, botConfig);
                }
            };
        }

        /**
         * Función para comprobar si Hubtype está activo
         */
        function _isEnabled() {
            let isEnabled = false;
            var deferred = $q.defer();

            CmsConfigSvc.getProperty('chatbot_hubtype').then(function (config) {
                // Comprobamos que el Hubtype esté soportado en el idioma actual
                var supportedLanguage = false;

                if (config.active && _checkSupportedLanguages(config)) {
                    supportedLanguage = true;
                }

                // Comprueba si Hubtype debe estar activo en la página actual
                var enabledInPage = false;

                enabledInPage = _.find(config.sections, function (section) {
                    if (section === inditex.iPage) {
                        return true;
                    }
                });

                if (supportedLanguage && enabledInPage) {
                    isEnabled = true;
                }

                deferred.resolve(isEnabled);
            });

            return deferred.promise;
        }

        /**
         * Función para obtener los datos del usuario actual
         */
        function _getDataFromUser() {
            var username = '';
            var loginId = '';
            var email = '';

            if (inditex.iUserJSON) {
                if (inditex.iUserJSON.firstName && inditex.iUserJSON.lastName) {
                    username = `${inditex.iUserJSON.firstName} ${inditex.iUserJSON.lastName}`;
                }

                if (inditex.iUserJSON.identity.userId) {
                    loginId = inditex.iUserJSON.identity.userId;
                }

                if (inditex.iUserJSON.email) {
                    email = inditex.iUserJSON.email;
                }
            }

            return {
                extra_data: {
                    store: inditex.iCountryCode,
                    language: DUTTI_CONS.i_languages[inditex.iLangId] || inditex.iCountryCode,
                    name: username,
                    login: loginId,
                    mail: email
                }
            };
        }

        /**
         * Función para comprobar si Hubtype está soportado para el idioma actual
         */
        function _checkSupportedLanguages(config) {
            if (config.languages.indexOf(inditex.iLangId.toString()) !== -1) {
                return true;
            }

            return false;
        }
    }
})(window.itxApp);
